import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import { Symbol } from "../reels/Symbol";
import { Sound } from "../sound/Sound";

export class MXRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.isMaxWinByMXSymbol();
    }

    public start(controller: ISimplePresentationRunnerController): void {
        controller.setSkipCallback();

        Game.keypadPlugin.setZeroBetSpinCounter(-1);

        const tl: gsap.core.Timeline = gsap.timeline();
        const mxSymbol: Symbol | null = Game.mxSymbol;

        // if complete MX visible at once, screen shake controlled from Symbol constructor
        if (!Game.hasMXLandedAtOnce()){
            tl.add(Game.shakeScreen());
        }

        tl.to(this, {
            duration: 0.2
        });

        if (mxSymbol){
            tl.add(mxSymbol.playMXAnimations());
        }

        tl.add(() => {
            Game.soundPlayer.playSound(Sound.WIN_CAP_INTRO, 1);
        }, 0.75);

        tl.add(Game.mxCelebration.showMXBanner(() => {
            controller.finish();
        }));
    }
}